/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ContactType = 'Undefined' | 'Mobile' | 'Phone' | 'Email' | 'Fax' | 'Url' | 'DataBox';

export const ContactType = {
    Undefined: 'Undefined' as ContactType,
    Mobile: 'Mobile' as ContactType,
    Phone: 'Phone' as ContactType,
    Email: 'Email' as ContactType,
    Fax: 'Fax' as ContactType,
    Url: 'Url' as ContactType,
    DataBox: 'DataBox' as ContactType
};